var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFuelType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 99,
    viewBox: "0 0 96 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2521",
    "data-name": "Rechteck 2521",
    width: 72,
    height: 72,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_53_2",
    "data-name": "Komponente 53 \\u2013 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 48,
    ry: 49.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 47,
    ry: 48.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon--fluessiggas",
    transform: "translate(13 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3310",
    "data-name": "Gruppe 3310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3309",
    "data-name": "Gruppe 3309",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5853",
    "data-name": "Pfad 5853",
    d: "M38.645,15.376,33.112,5.028A2.144,2.144,0,0,0,29.468,5S13.023,39.9,12.976,40.008a19.76,19.76,0,0,0-1.747,9.263A19.8,19.8,0,0,0,50.795,48.2a19.943,19.943,0,0,0-.123-2.212",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5854",
    "data-name": "Pfad 5854",
    d: "M18.867,48.314a12.964,12.964,0,0,0,7.707,11.06",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5855",
    "data-name": "Pfad 5855",
    d: "M52.587,28.841c.6-.364,1.139-2.065,1.139-2.065,4.374,2.793,3.047,12.477-4.555,12.086A5.8,5.8,0,0,1,43.39,34.5a8.637,8.637,0,0,1,.195-5.289,10.6,10.6,0,0,1,8.761-6.934C50.13,26.471,52.587,28.84,52.587,28.841Z",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5856",
    "data-name": "Pfad 5856",
    d: "M41.536,20.6l-2.891-5.226C27.537,22.443,30.908,46.95,50.211,45.96c9.42-.422,13.19-6.05,14.678-11.027a21.8,21.8,0,0,0-.494-13.384C58.736,5.289,42.149,4,42.149,4,47.776,14.6,41.536,20.6,41.536,20.6Z",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFuelType2);
export default __webpack_public_path__ + "static/media/dashboard-fuel-type-2.e9422b5230f2a639e925c1776885f892.svg";
export { ForwardRef as ReactComponent };